module.exports = __webpack_public_path__ + "files/b621bf8337f8ee6b4cf4204a73f52058.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-bold-webfont.eot
 ** module id = 410
 ** module chunks = 0
 **/